export const isMediaServerUrl = url => {
  if (!url) {
    return false
  }
  return url.includes('media://')
}
